import React from 'react'

import img_me from '../images/Polymedia-Peter_van_der_Meer.jpg';


export default class extends React.Component {

  render() {
    document.title = "Contact - Peter van der Meer - Ik maak LinkedIn gemakkelijk. - Ghostin.nl";
    return (
      <div className="full big black">
        <div className="wrap content-block">

          <h2>Contact</h2>

          <div className="col-2" style={{margin:"0 auto", display:"block"}}>
            <div className="card more-rounded card-black">
              <a href="https://polymedia.nl" target="_blank" rel="noopener noreferrer"><h3 style={{margin:"0"}}>Polymedia</h3></a>
              <small style={{ margin: "0 0 1em", display:"block" }}>(Ghostin is een handelsnaam van Polymedia)</small>
              <p style={{ margin: "0" }}>Overvliet 21<br/>3545 NG Utrecht</p>
              <small style={{ margin: "0 0 1em", display:"block" }}>(Geen bezoekadres)</small>
              <p style={{ margin: "0 0 1em" }}><b>KvK</b> 78301629<br/><b>BTW</b> NL003318183B10</p>
              <p><img src={img_me} alt="Foto Peter van der Meer" className="testimonial-thumbnail" /><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer">LinkedIn Peter van der Meer</a>, Autoriteit Bouwer & Eigenaar bij Ghostin.</p>
              <p style={{ margin: "1em 0 1em" }}><b>Tel</b> 06 5756 7014<br /><b>E-mail</b> peter@ghostin.nl</p>
              <h3 style={{ margin: "2em 0 1em" }}>Wil jij jouw persoonlijke blauwdruk bespreken?</h3>
              <p style={{ textAlign: "left", marginBottom: "2em" }}>Laten we 15 minuten plannen voor een persoonlijke "LinkedIn Diagnose" voor jouw profiel en bedrijf. Geen pitch onder hoge druk, maar waardevol en strategisch inzicht.<br/><br/>Ik weet dat je een bedrijf te runnen hebt. Mijn proces vraagt slechts 30 minuten per maand, en af en toe jouw halfbakken notities doordeweeks. Ik doe het zware werk, jij bepaalt het verhaal.</p>
              <div><a href="https://calendar.app.google/XPw5Ho3npLVVWrSD9" target="_blank" rel="noopener noreferrer" className="btn btn-fat btn-if btn-if-fill-gold">Plan 15 minuten in</a></div>
            </div>
          </div>

        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Contact.js